import { type ID, ProjectActions } from '@octopus-do/octopus-project-core'
import { LoaderActions } from '@store/loaders'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { SocketActions } from '@store/socketSaga'
import { UploadResultActions } from '@store/uploadResultSaga'
import { commitProjectRequest } from '@storeOld/actionCreators'
import type { AxiosError } from 'axios'
import { call, put, select } from 'redux-saga/effects'

import request from '@/services/request'
import type { AttachmentItem } from '@/types'
import type { RequestActions } from '../actions'

export function* attachFile({
  payload: { file, fileId, attachId },
}: ReturnType<typeof RequestActions.attachFile>) {
  const projectId: ID | null = yield select(
    migrationProjectSelector.getProjectId
  )

  if (!projectId) {
    return
  }

  yield put(LoaderActions.set(fileId))

  yield put(
    SocketActions.emit({
      eventName: 'sync',
      payload: LoaderActions.set(fileId),
    })
  )

  try {
    const formData = new FormData()
    formData.append('file', file)

    const response: AttachmentItem = yield call(
      request.multipart,
      `/projects/${projectId}/attachments/${fileId}`,
      formData
    )

    yield put(UploadResultActions.success(response))

    yield put(
      SocketActions.emit({
        eventName: 'sync',
        payload: UploadResultActions.success(response),
      })
    )
  } catch (error) {
    yield put(
      commitProjectRequest(
        ProjectActions.attachments.delete({ ids: [attachId] })
      )
    )

    yield put(UploadResultActions.error(error as AxiosError))
  }

  yield put(LoaderActions.unset(fileId))

  yield put(
    SocketActions.emit({
      eventName: 'sync',
      payload: LoaderActions.unset(fileId),
    })
  )
}
